// Function to format ISO8601 date to "dd-mm-yyyy" format
export const formatDate = (isoTimestamp: string): string => {
  const date = new Date(isoTimestamp);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());

  return `${day}-${month}-${year}`;
};